export default __webpack_public_path__ + "static/media/DK.1f43f653.svg";